module.exports = __webpack_public_path__ + "img/info.40191525.jpg";